'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default [function() {
    return {
        restrict: 'A',
        template: require('../view/okved-node.html'),
        controller: ['$scope', '$element',
                     function($scope, $element) {

                        $scope.isOpen = $scope.path.some(n => n.id === $scope.item.id);

                        $scope.$watch('path', () => {
                            $scope.isOpen = $scope.path.some(n => n.id === $scope.item.id);
                            if (!$scope.path.length) return;
                            const lastElement = $scope.path.slice(-1)[0];
                            if ($scope.item.id === lastElement.id) {
                                setTimeout(() => {
                                    if ($element && $element[0] && $element[0].children[0]) {
                                        if ($element[0].children[0].scrollIntoViewIfNeeded) {
                                            $element[0].children[0].scrollIntoViewIfNeeded();
                                        } else {
                                            $element[0].children[0].scrollIntoView();
                                        }
                                    }
                                }, 0);
                            }
                        })
                     }],
    };
}];
